const stickyShare = () => {
    const targetItem = document.querySelector(".article-share");
    const container = document.querySelector(".content");
    const startPosition = (targetItem.offsetTop - 130);
    const endPosition = container.scrollHeight + startPosition - targetItem.scrollHeight;

    const setStickyPosition = () => {
        if (targetItem && container) {
            if (window.innerWidth >= 1024 && window.pageYOffset >= startPosition && window.pageYOffset <= endPosition) {
                targetItem.classList.add("sticky");
            } else {
                targetItem.classList.remove("sticky");
            }
        }
    };

    window.addEventListener("load", setStickyPosition);
    window.addEventListener("scroll", setStickyPosition);
    window.addEventListener("resize", setStickyPosition);
};

export default stickyShare;



// WEBPACK FOOTER //
// ./assets/js/modules/sticky-share.js